import {
  ProjectViewProjectsCollection,
  ThreadsCollection,
} from '@freelancer/datastore/collections';
import { deepSpread } from '@freelancer/datastore/core';
import { PrivacyLevelApi } from 'api-typings/messages/messages_types';
import { ProjectStatusApi } from 'api-typings/projects/projects';
import { addUpdateTransformer } from './document-creators';

export function addUpdateTransformers(authUserId: number) {
  addUpdateTransformer<ProjectViewProjectsCollection>(
    'projectViewProjects',
    (authUid, project, delta) => ({
      ...deepSpread(project, delta),
      ...(delta.hiremeOpenedForBidding
        ? { hireme: false, status: ProjectStatusApi.ACTIVE }
        : {}),
    }),
  );

  addUpdateTransformer<ThreadsCollection>('threads', (_, document, delta) => {
    return {
      ...document,
      ...delta,
      ...(delta.isBlocked !== undefined
        ? {
            writePrivacy: delta.isBlocked
              ? PrivacyLevelApi.NONE
              : PrivacyLevelApi.MEMBERS,
          }
        : {}),
    };
  });
}
